var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 439",
    viewBox: "0 0 36.015 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h36.015v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m36.016 32.654-10.387-10.4a14.046 14.046 0 0 0-1.35-18.091 14.223 14.223 0 1 0-20.105 20.12 14.02 14.02 0 0 0 18.091 1.332L32.667 36ZM7.2 21.259a9.95 9.95 0 0 1 0-14.075 9.95 9.95 0 0 1 14.075 0 9.95 9.95 0 0 1 0 14.075 9.95 9.95 0 0 1-14.075 0"
  }))));
};
export default SvgSearch;